/**
 * Consolidated omniture mapping.
 * @author  rmunson, kconstance
 * @name Tracking
 * @example  
 *		//Basic calls
 *		var om=new module.Omiture(sprops);
 *		om.assign();
 *		om.fire();
 *
 *		//Custom fire method
 *		var OmitureLinkTracking=module.create(function(sprops){
 *			Omniture.call(this,sprops);
 *		});
 *		OmnitureLinkTracking.prototype.fire=function(callingObj){
			callingObj=callingObj||{
				href : "http://myGenericURL"
			};
			s.tl(callingObj,'o',
				this.prop14 || this.prop1   || this.prop38  || this.prop44 || this.prop45 ||
				this.prop16 || this.prop17  || this.prop27 || this.prop23 || this.prop28 ||
				this.events
			);       
		};

		var om=new OmnitureLinkTracking(sprops);
		om.assign();
		om.fire();
 * 
 *
 */
define('tracking/omniture',[],function () {

	var 
		EMPTY="",
		rCOOKIE=/\s*;\s*/,
		rCAP=/(?:^|([\W_-]))(\w)/g,
		trackingContainer,
		imageTag={
			open  : '<img src="',
			close : '"/>'
		},
		PROP="prop",
		EVAR="eVar",
		p=0,
		count=75,

	consts = {
		dynamicView : "Dynamic Page View"
	},

	/* Default (consolidated) Omniture variable mapping
		@see https://wiki.mlbam.com/display/omniture/Omniture+Variable+Mapping
	*/
	propertyMap={
		prop1	: "site_sectionTitle",			// Sub Section
		prop2	: "content_articleId",			// Article Content ID
		prop3	: "site_playerId",				// Player ID
		prop4	: "user_searchTerms",			// Internal Search Terms, maps to eVar2
			//Creating a generator to handle the capitalization
		prop5	: "site_formFactor",			// Page Mode (Form Factor)
			//Creating a generator to handle the capitalization
		prop6	: "site_orientation",			// Page Mode (Orientation)
		//prop7 : generated						// Page Mode (Form Factor : Orientation)
		prop10	: "content_mediawallCid",		// TODO (When we have a mediawall): Media Wall Content ID
		prop12	: "dynamic_component",			// Dynamic Component
		//prop13  : generated					// Dynamic Component Location
		prop14	: "dynamic_componentAction",	// Dynamic Component Action
		//prop15  : generated					// Dynamic Component Page Mode (Form Factor: Orientation)
        prop16	: "component",      			// MP4: Component
        prop17	: "component_activity",     	// MP4: Component Activity
        prop18	: "media_mpSponsor",			// MP4: Sponsor
        // prop20 has a fallback generator
        prop20	: "media_mpIpid",				// MP4: IPID
		// prop22 has a fallback generator
		prop22  : "user_ipid",					// MLB IPID
		prop25	: "media_streamId",				// Stream: Media ID
		prop26	: "media_playerType",			// Stream: Media Player Type
		prop27	: "media_playerContext",		// Stream: Media Player Context
		prop28	: "media_playerVersion",		// Stream: Media Player Version
		prop29	: "media_streamType",			// Stream: Stream Type
		prop30	: "media_streamTitle",			// Stream: Video Title
		prop32	: "media_streamVideo",			// Stream: Video Index Name
		prop40	: "gameday_matchup",			// Gameday Matchup
		prop43	: "media_streamPlayer",			// Stream: Player Flavor
		prop47	: "media_streamState",			// Stream: Live/Archive
		prop49	: "media_embedHost",			// Video: Embedded Host
		prop53	: "media_sponsor",				// Media: Sponsor
		prop54	: "media_showTime",				// Media: Show Time
		prop56	: "content_mediaWall3rd",		// Mediawall: Third Auto Rotation
		prop58	: "media_embedId",				// Video Copy/Embed ContentID
		prop61	: "content_articleHeadline",	// Article Headline
		prop62	: "content_articleAuthor",		// Article Author
		prop63	: "content_articleSponsor",		// Article Sponsor
		prop65	: "site_club",					// WAP: Club Name
		prop66	: "user_deviceId",				// WAP: Device ID
		prop67	: "user_deviceManufacturer",	// WAP: Manufacturer
		prop68	: "user_deviceCarrier",			// WAP: Carrier
		prop69	: "user_cookie",				// WAP: Cookie Value
		prop70	: "user_ip",					// WAP: IP Address
		prop71	: "gameday_inning",				// WAP: Gameday Inning
		prop72	: "user_userAgent",				// WAP: User Agent
		eVar4   : "site_affiliateId",			// AffiliateID
		eVar5   : "action_download",			// Download Flow
		eVar6   : "media_mpOffer",				// MP4 Upgrade Offer
		eVar7   : "media_mpFlow",				// MP4 Commerce Flow Type
		eVar8   : "media_mpSkin",				// MP4 Skin Flavor
		eVar9   : "media_mpEntryPoint",			// MP4 Entry Point
		eVar10  : "action_click",				// Track Click Links
		//eVar11 :	generated					// MLB IPID
		eVar13  : "media_videoStart",			// Video Start/Complete Context
		eVar14  : "tcid",						// TCID
		eVar17  : "gameday_premiumConversion",	// Gameday Premium Conversion
		eVar19  : "content_mediawallCid",		// Media Wall CID
		eVar21  : "ticket_decisionLink",		// Ticket Decision Link
		eVar22  : "ticket_finalLink",			// Ticket Final Link
		eVar23	: "action_formId",				// Form Code
		eVar26	: "site_searchPosition",		// Internal Search Position
		eVar27	: "site_searchType",			// Internal Serach Result Type
		eVar28	: "media_streamId",				// Stream: Media ID
		eVar41	: "user_searchQuery",			// Organic Search Query
		eVar49	: "media_embedHost",			// Video: Embedded Host
		eVar51	: "ticket_waitId",				// TDC Waiting EventID
		eVar52	: "ticket_waitHost",			// TDC Waiting Host
		eVar53	: "media_sponsor",				// Media: Sponsor
		eVar54	: "media_showTime",				// Media: Show Time
		eVar59	: "content_embedHost"			// Photo Galleries: Embed Host
	},
	getOrientation=function(){
		var width  = window.innerWidth || document.documentElement.clientWidth;
		var height = window.innerHeight || document.documentElement.clientHeight;
		var orientation = (height >= width) ? "Portrait" : "Landscape";
		return orientation;
	},
	capitalizeReplace=function($0,$1,$2){
	    return ($1||"")+$2.toUpperCase();
	},
	capitalize=function(str){
		return (str||"").toLowerCase().replace(rCAP,capitalizeReplace);
	},
	getUserData=function(fresh){
		var i=0,
			u={},
			cookie,
			cookies=document.cookie.split(rCOOKIE),
			len=cookies.length;

		for(;i<len;i++){
			cookie=cookies[i].split('=');
			u[cookie[0]]=cookie[1];
		}
		return u;
	};

	function getDeviceType() {
		if (window.DeviceType) {
			return window.DeviceType.device === 'phone' ? 'Smartphone' : capitalize(window.DeviceType.device);
		} else {
			return undefined;
		}
	}

	function create(child,parent){
		child.prototype=Object.create(parent && parent.prototype||Omniture.prototype);
		return child;
	}
	/**
	 * Create a shared container for tracking pixels (used internally )
	 * @private
	 * @return {object jQuery} Returns a jQuery collection pointing to a div used for dumping tracking pixels
	 */
	function createTrackingContainer(){
		return trackingContainer=trackingContainer||$("<div style='display:hidden' hidden></div>");
	}

	/**
	 * Base constructor for all Omniture tracking objects.  Adds convenice
	 * of allowing simple instanceof checks against child objects that adopt it's prototype.
	 * Child objects then have the benefit of inheriting the default values for the consolidated object,
	 * while having the convenience of a simple hasOwnProperty check determing value precedence on all pre-fire filters.
	 */
	function Omniture(props){
		this.props=props||{};
	}
	/**
	 * Omniture object prototypal root for all Omniture tracking objects.
	 * all children will inherit or override from this base set.
	 */
	Omniture.prototype={
			/**
			 * Assign the mapped prop/var properties over to the specified object (s by default).
			 * If necessary, values not needed for for the current tracking call will be reset to their 
			 * defaults.
			 *
			 * @see  https://wiki.mlbam.com/display/omniture/Omniture+Variable+Mapping
			 * @param  {object} [target]  Object to recieve the supplied tacking values. Defaults to the omniture global s.
			 * @return {object}           Target object with newly mapped values.
			 */
			assign  : function(target){
				target=target||window.s;
				var key,mappedKey,val,
					props=this.props,
					map=this.propertyMap,
					generators=this.generators;

				/*
					Catch all pass-through properties. (pageName, channel, etc)
				 */
				for(key in props){
					if(target.hasOwnProperty(key)){
						this[key]=props[key];
					}
				}

				for(key in this){

					mappedKey=map[key];
					val=props[mappedKey]
					if(val){
						this[key]=val;
					}

					/* 	If the key is explicit in the object instance, always assign it.
						Otherwise if the target (typically the s code object) has a property assigned,
						we'll need to clear it using the default value assigned in the prototype. 
					 */
					if(this.hasOwnProperty(key) || target.hasOwnProperty(key)){
						target[key]=this[key];
					}
				}
				for(key in generators){
					val=generators[key](this,props);
					if(val||target[key]){
						target[key]=val || EMPTY;
					}
						
				}
				return target;
			},
			/**
			 * In the event that s.t() returns a pixel (or drawing a simple pixel is preferred),
			 * drawPixel can append to the tracking container div.
			 * @uses   createTrackingContainer
			 * @param  {mixed} pixelString Image object, image string, or url to be drawn.
			 * @return {object jQuery}     jQuery collection containing the writting img tag.
			 */
			drawPixel : function(pixel){
				if(!pixel){
					return false;
				}
				return $(pixel.toString().charAt(0)==='<' ? 
					pixel : imageTag.open + pixel + imageTag.close
				).appendTo(createTrackingContainer());
			},
			/**
			 * Execute the tracking call.
			 * @return {mixed} Pixel used for s_code draw, or false if no additional processing was necessary.
			 */
			fire	: function(){
				var s_code=window.s.t();
				this.s_code=s_code;
				if(s_code){
					return this.drawPixel(s_code);
				}
				return false;
			},
			/**
			 * Generator rules used to generate properties that require
			 * a programaticlly evalualable procedure, or additional processing.
			 * @param {object Omniture} o Omniture instance
			 * @param {object}          p Property object (equivalent to o.props)
			 * @type {Object}
			 */			
			generators : {
					// Page Mode (Form Factor)
				prop5   : function(o,p){
					return capitalize(o.prop5);
				},
					// Page Mode (Orientation)
				prop6   : function(o,p){
					return capitalize(o.prop6);
				},
					// Page Mode (Form Factor: Orientation)
				prop7 	: function(o,p){
					return o.prop7||o.prop5 && this.prop5(o,p) + ": " + this.prop6(o,p);
				},
					// Dynamic Page Views
				prop11  : function(o,p){
					return (o.prop11||p.isDynamic) && consts.dynamicView;
				},
					// Dynamic Component Location
				prop13  : function(o,p){
					return o.pageName||s.pageName;
				},
					// Page Mode (Form Factor: Orientation)
				prop15 	: function(o,p){
					return o.prop7||o.prop5 && this.prop5(o,p) + ": " + this.prop6(o,p);
				},
                    // MP4: IPID - functions as a fallback if no ipid is specified
                prop20  : function(o,p){
                    return o.prop20||o.prop22||getUserData().ipid;
                },
					// MLB IPID - functions as a fallback if no ipid is specified
				prop22  : function(o,p){
					return o.prop22||getUserData().ipid;
				},
					// Stream : IPID
				prop31 	: function(o,p){
					return o.prop25 && this.prop22(o,p);
				},
					// Dynamic MLB IPID
				evar11  : function(o,p){
					return p.isDynamic && this.prop22(o,p);
				},
					// Video IPID
				evar18  : function(o,p){
					return o.prop25 && this.prop22(o,p);
				},
					// Page Mode (Form Factor)
				eVar34	: function(o,p){
					return this.prop5(o,p);
				},
					// Page Mode (Orientation)
				eVar35	: function(o,p){
					return this.prop6(o,p);
				},
					// Page Mode (Form Factor: Orientation)
				eVar36	: function(o,p){
					return this.prop7(o,p);
				},
					// Gameday Matchup
				evar40 : function(o){
					return o.prop40;
				}

			},
			/**
			 * Add an event, or comma-separated list of events
			 * to the current instance object.
			 * @param {string} evts Event or event list to add to the call.
			 */
			addEvents : function(evts){
				var eventList=this.events? this.events.split(','):[];
				return this.events=eventList.concat(evts||"".split(',')).join(',');
			},
			props       : {},
			propertyMap : propertyMap
		};

		/* Push all of the props/eVars onto the prototype */
		for(;p<count;p++){
			Omniture.prototype[PROP+p]=Omniture.prototype[EVAR+p]=EMPTY;	
		}
		Omniture.prototype.events=EMPTY;
	/**
	 * Omniture tracking config for Mobile sites. Applies
	 * a known map of mobile-site specific tracking data to their associated Omniture prop/eVar values.
	 * 
	 * @constructor
	 * @param {object} props Tracking data.
	 */
	function OmnitureMobile(props){
		if(!(this instanceof OmnitureMobile)){
			return new OmnitureMobile(props);
		}
		Omniture.call(this,props);
		this.assign();
	}

	OmnitureMobile.prototype=Omniture.prototype;

	/**
	 * Async omniture calls.
	 * 
	 * @constructor
	 * @param {object} props Tracking data.
	 */
	function OmnitureAsync(props){
		var orientation = getOrientation();
		var trackingClient = {
			"site_formFactor"  : getDeviceType(),
			"site_orientation" : orientation
		};

		$.extend(props, trackingClient);
		Omniture.call(this,props);
	}
	create(OmnitureAsync).prototype.fire=function(callingObj){
		callingObj=callingObj||{
			href : "http://myGenericURL"
		};
		window.s.tl(callingObj,'o',
			this.prop14 || this.prop1   || this.prop38  || this.prop44 || this.prop45 ||
			this.prop16 || this.prop17  || this.prop27 || this.prop23 || this.prop28 ||
			this.events
		);       
	};

	return {
	    /**
	     * Expose OmnitureAsync object for consumption.
	     * @see  OmnitureAsync
	     * @type {function}
	     */
	    OmnitureAsync  : OmnitureAsync,
	    /**
	     * Expose OmnitureMobile object for consumption.
	     * @see  OmnitureMobile
	     * @type {function}
	     */
	    OmnitureMobile  : OmnitureMobile,
	    /**
	     * Expose Omniture object for consumption.
	     * @see  Omniture
	     * @type {function}
	     */
	    Omniture    : Omniture,

	    /**
	     * Expose the internal capitalization formatter.  
	     * Internall this is used in several generators automatically, but is exposed
	     * for convenience.
	     *
	     * @see  capitalize
	     * @type {function}
	     */
	    capitalize  : capitalize,

	    /**
	     * Standard prototypal inheritance only please.  Pass in a child
	     * constructor, and inherit from Omniture or another provied parent.
	     * @param  {function} child  Child tracking object constructor.
	     * @param  {funtion} [parent] Optional parent object whos prototype you with to adopt.
	     *                            Defauts to Omniture.
	     * @return {function}         Child constructor with new prototype.
	     */
	    create      : create,

	    /**
	     * Gather user data for prop/eVar population.
	     * Internall this is used in several generators automatically, but is exposed
	     * for convenience.
	     * @type {function}
	     */
	    getUserData	: getUserData

	};

});
